import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, message } from "antd";
import React, { useState } from "react";
// import KitDetails from "./KitDetails";
import AssignSampler from "./AssignSampler";
import { actions } from "../slice";
import { useDispatch, useSelector } from "react-redux";
import * as selectors from "../selectors";
import AddLogistic from "./AssignLogisticToKit";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { reverse } from "named-urls";
import routes from "../../../../../../routes";

function KitAction({ record, fetchKitLists, userRole }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const allKitsStatus = useSelector(selectors.selectFilterStatus);
  const [isLoading, setIsLoading] = useState(false);
  // const [isKitDetailsModalVisible, setIsKitDetailsModalVisible] =
  //   useState(false);
  const [isAssignSamplerModalVisible, setIsAssignSamplerModalVisible] =
    useState(false);
  const [isAssignLogisticModalVisible, setIsAssignLogisticModalVisible] =
    useState(false);
  const kitStatus = record?.status;

  const allKitStatusMap = allKitsStatus.reduce((acc, item) => {
    acc[item.value] = item._id;
    return acc;
  }, {});

  const handleUpdateKitStatus = (statusValueFrom, statusValueTo) => {
    setIsLoading(true);
    const postData = [
      {
        samplerKitId: record?._id,
        statusId: allKitStatusMap[statusValueTo],
      },
    ];

    dispatch(
      actions.updateKitStatus({
        postData,
        onSuccess: () => {
          setIsLoading(false);
          message.success(
            `Kit status updated successfully ${statusValueFrom} to ${statusValueTo}`
          );
          fetchKitLists();
        },
        onFailure: () => {
          setIsLoading(false);
          message.error("Failed to update kit status");
        },
      })
    );
  };

  const MenuItem = ({ key, label, handler }) => {
    return (
      <Menu.Item
        key={key}
        style={{
          fontWeight: 600,
          margin: 0,
        }}
        onClick={handler}
      >
        {label}
      </Menu.Item>
    );
  };
  return (
    <>
      <Dropdown
        overlay={
          <Menu
            style={{
              minWidth: "200px",
              borderRadius: "8px",
              padding: "6px",
              boxShadow: "0 4px 24px 0 rgba(44, 62, 80, 0.12)",
            }}
          >
            <MenuItem
              key="1"
              label={"View details"}
              handler={() =>
                history.push(
                  reverse(`${routes.backOffice.assets.details.view}`, {
                    assetId: record?._id,
                  })
                )
              }
            />
            {userRole !== "agnext_reviewer" && kitStatus?.value === "packed" ? (
              <MenuItem
                key="2"
                label={"Move to out for delivery"}
                handler={() =>
                  handleUpdateKitStatus("packed", "out for delivery")
                }
              />
            ) : null}

            {userRole !== "agnext_reviewer" &&
            kitStatus?.value === "out for delivery" ? (
              <MenuItem
                key="3"
                label={"Mark as delivered"}
                handler={() =>
                  handleUpdateKitStatus("out for delivery", "delivered")
                }
              />
            ) : null}

            {userRole !== "agnext_reviewer" &&
            (kitStatus?.value === "pending" ||
              kitStatus?.value === "packed") ? (
              <MenuItem
                key="4"
                label={record?.sampler?._id ? "Edit Sampler" : "Assign Sampler"}
                handler={() => setIsAssignSamplerModalVisible(true)}
              />
            ) : null}

            {userRole !== "agnext_reviewer" && (
              <MenuItem
                key="5"
                label={
                  record?.assignedLogistic?._id || record?.trackingId
                    ? "Edit Logistic"
                    : "Add Logistic"
                }
                handler={() => setIsAssignLogisticModalVisible(true)}
              />
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button type="text" icon={<MoreOutlined />} />
      </Dropdown>

      <AssignSampler
        key={record?._id}
        isAssignSamplerModalVisible={isAssignSamplerModalVisible}
        setIsAssignSamplerModalVisible={setIsAssignSamplerModalVisible}
        kitData={{ samplerKit: record }}
        // setIsSuccessModalVisible={setIsSuccessModalVisible}
        fetchKitLists={fetchKitLists}
        from="action"
      />

      {/* {isKitDetailsModalVisible && (
        <KitDetails
          isKitDetailsModalVisible={isKitDetailsModalVisible}
          setIsKitDetailsModalVisible={setIsKitDetailsModalVisible}
          KitDetail={record}
          isLoading={isLoading}
          buttonLabel={
            kitStatus?.value === "pending"
              ? "Assign Sampler"
              : kitStatus?.value === "packed"
              ? "Move to Out for delivery"
              : "Marked Delivered"
          }
          buttonHandler={
            kitStatus?.value === "pending"
              ? () => {
                  setIsKitDetailsModalVisible(false);
                  setTimeout(() => {
                    setIsAssignSamplerModalVisible(true);
                  }, 100);
                }
              : kitStatus?.value === "packed"
              ? () => handleUpdateKitStatus("packed", "out for delivery")
              : () => handleUpdateKitStatus("out for delivery", "delivered")
          }
        />
      )} */}
      {isAssignLogisticModalVisible && (
        <AddLogistic
          isAssignLogisticModalVisible={isAssignLogisticModalVisible}
          setIsAssignLogisticModalVisible={setIsAssignLogisticModalVisible}
          KitDetail={record}
          fetchKitLists={fetchKitLists}
        />
      )}
    </>
  );
}

export default KitAction;
